import intl from 'react-intl-universal';
import { RowInfo } from 'react-table';
import ClickableCell from 'components/ClickableCell/ClickableCell';
import { PAST_MEETING_PARTICIPANTS, PAST_MEETING_ROUTE } from 'constants/pastMeetings';
import { formatMinutesForDisplay, formatUnixTimeStampForDisplay } from 'utils/date-time-utils';
import React from 'react';

interface PastMeetingRow {
  value: number;
}

export default (history: { push: Function }) => [{
  Header: intl.get('name'),
  accessor: 'meetingName',
  Cell: (row: RowInfo) => {
    const { meetingName } = row.original;
    return (
      <ClickableCell
        id={`liveMeeting-${meetingName}`}
        title={meetingName}
        isClickable={true}
        displayText={meetingName}
        clickHandler={() => {
          history.push(`${PAST_MEETING_ROUTE}/${row.original.conferenceId}/${PAST_MEETING_PARTICIPANTS}`);
        }}
      />
    );
  }
}, {
  Header: intl.get('meetingType'),
  accessor: 'conferenceType',
  sortable: false,
}, {
  Header: intl.get('extension'),
  accessor: 'extension',
  sortable: false,
}, {
  Header: intl.get('startTime'),
  accessor: 'startedAt',
  Cell: (row: PastMeetingRow) => row.value && formatUnixTimeStampForDisplay(row.value),
}, {
  Header: intl.get('duration'),
  accessor: 'duration',
  Cell: (row: PastMeetingRow) => row.value && formatMinutesForDisplay(row.value),
}, {
  Header: intl.get('participants'),
  accessor: 'totalParticipants'
}];
